module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Export","packName":"Name","packNamePlaceholder":"Name","sensorsSelected":"sensors selected","format":"Format","exportBtn":"Export Data"},"it":{"title":"Esporta","packName":"Nome","packNamePlaceholder":"Nome","sensorsSelected":"sensori selezionati","format":"Formato","exportBtn":"Esporta"}}')
  delete Component.options._Ctor
}
